import css from 'styled-jsx/css';

const styles = css.global`.banner_desk {
  display: none;
}

/* .banner_mobile a {
  display: flex;
  width: 100%;
}

.banner_mobile a img {
  width: 100%;
  object-fit: cover;
} */

.banner_mobile {
  display: flex;
  width: 100%;
  height:507px;
  background-image: url('assets/carros-eletricos/banner-mobi1312.png');
  background-repeat: no-repeat;
  background-size: cover;
  background-position: bottom;
}

.banner_mobile .ctn {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex-direction: column;
  gap: 8px;
  padding-top: 45px;
}

.banner_mobile .campanha_txt {
  font-family: 'SantanderText';
  font-style: normal;
  font-weight: 400;
  font-size: 28px;
  line-height: 28px;
  color: #ffffff;
  margin: 0;
}

.banner_mobile .campanha_txt b {
  font-weight: 600!important;
}

.banner_mobile .xxx_txt {
  font-family: 'SantanderText';
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 28px;
    /* text-align: right; */
    color: #ffffff;
    margin-top: 32px;
    max-width: 212px;
}

.banner_mobile a {
  width: 160px;
  height: 44px;
  margin: auto 0;

}

@media (min-width: 992px) {
  .banner_mobile {
    display: none;
  }

   .banner_desk {
    background-image: linear-gradient(360deg, rgba(255,255,255,0) 22%, #CC0000 22%, #CC0000 100%);
    display: flex;
    margin-bottom: 0px;
  }

  /* .banner_desk a {
    display: flex;
    width: 100%;
    height: auto;
  }

  .banner_desk a img {
    width: 100%;
    height: 325px;
    margin-top: 64px;
    object-fit: cover;
  } */
  .banner_desk .div_desk {
    background-image: url('assets/carros-eletricos/banner-desk1312.png');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    /* margin-top: 64px; */
    padding: 56px 56px 0px 40px;
    height: 325px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    flex-direction: column;
    box-sizing: content-box;
  }

  .banner_desk .vantagens_txt {
    font-family: 'SantanderHeadline';
    font-style: normal;
    font-weight: 400;
    font-size: 35px;
    line-height: 50px;
    color: #ffffff;
    margin: 32px 0 12px;
  }

  .banner_desk .vantagens_txt b {
    font-weight: 800!important;
  }

  .banner_desk .produtos_txt {
    font-family: 'SantanderText';
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    color: #ffffff;
    line-height: 28px;
    margin-bottom: 35px;
  }

  .banner_desk a {
    height: 48px;
    width: 148px;
  }
}

@media (min-width: 1200px) {
  .banner_desk .div_desk {
    background-position: right;
  }

}

@media (min-width: 1400px) {
  .banner_desk .div_desk {
    padding: 0px 56px 0px 40px;
  }
  .banner_desk .vantagens_txt {
    font-size: 40px;
    line-height: 60px;
    margin: 33px 0 12px;
  }

}`;

export default styles;